import type { ReactElement } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';

import { minLength, required } from 'common/utils/validations';
import { CITextField } from 'common/viewcomp/forms/fields/text';

interface Props {
    disabled?: boolean;
}

export const PasswordTextField = ({ disabled }: Props): ReactElement => {
    const { t } = useTranslation('auth');
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = (): void => {
        setShowPassword((old) => !old);
    };

    return (
        <CITextField
            t={t}
            className="login_input_field"
            id="password"
            name="password"
            labelI18NKey="login.password_label"
            type={showPassword ? 'text' : 'password'}
            margin="normal"
            fullWidth
            required
            maxLength={16} // temporary until specs are defined
            disabled={disabled}
            validations={[required(), minLength(8, 'error.too_short')]}
            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        id="visibility_toggle"
                        aria-label={t('login.toggle_password')}
                        aria-pressed={showPassword}
                        onClick={handleClickShowPassword}
                        size="large"
                        type="button"
                    >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                </InputAdornment>
            }
        />
    );
};
